import { z } from "zod";
import { Id, IsoDateTime } from "./common.ts";

export const VenueType = z.enum(["bar", "pub", "restaurant", "live_music"]);
export type VenueType = z.infer<typeof VenueType>;

export const Venue = z.object({
  id: Id,
  name: z.string().min(1),
  nameTh: z.string().optional(),
  type: VenueType,
  address: z.string().optional(),
  timezone: z.string().default("Asia/Bangkok"),
  isActive: z.boolean().default(true),
  createdAt: IsoDateTime,
  updatedAt: IsoDateTime,
});
export type Venue = z.infer<typeof Venue>;

export const CreateVenue = Venue.pick({
  name: true,
  nameTh: true,
  type: true,
  address: true,
  timezone: true,
});
export type CreateVenue = z.infer<typeof CreateVenue>;
